module.exports = __webpack_public_path__ + "img/icon_guanggao_home.ac023af8.png";